import React from 'react';

import styled from '@emotion/styled';
import { breakpoints } from '@rtkwlf/fenrir-react';
import { WidgetSizeColumnEnum } from '@rtkwlf/insights';

const isChrome = navigator.userAgent.includes('Chrome');

export const LayoutGrid = styled.div({
  '@media print': {
    marginBottom: '100mm !important',
    // zoom property works well in Chrome and yields the best result
    // but zoom property is not supported by other browsers so using transform.
    ...(isChrome
      ? {
          zoom: '60%',
        }
      : {
          transform: 'scale(0.6)',
          transformOrigin: 'top left',
          width: '167%',
        }),
  },
  display: 'grid',
  gap: '24px',
  gridAutoRows: 'minmax(350px, auto)',
  gridTemplateColumns: 'repeat(2, 1fr)',
});

type LayoutCellProps = {
  id?: string;
  columnSize: WidgetSizeColumnEnum;
};

export const LayoutCell = React.memo(
  styled.div<LayoutCellProps>(({ columnSize }) => {
    const columnSpan = columnSize === WidgetSizeColumnEnum.Full ? 2 : 1;

    return {
      breakInside: 'avoid',
      [`@media (max-width: ${breakpoints.tablet})`]: {
        gridColumn: 'span 2',
      },
      gridColumn: `span ${columnSpan}`,
    };
  }),
);
